import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitSignup({ name, email, why }) {
  const res = await axios.post(`${API}/signup`, {
    name: name.trim() || null,
    email: email.trim(),
    why: why.trim() || null,
  });
  return res.data;
}

export function extractErrorMessage(err) {
  const detail =
    err?.response?.data?.detail?.[0]?.msg ||
    err?.response?.data?.detail ||
    "Something broke on our end. Try again in a moment.";
  return typeof detail === "string" ? detail : "Invalid input.";
}
